import PropTypes from 'prop-types';
import React from 'react';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import Tooltip from '../../components/molecules/Tooltip';
import { Checkbox } from '../../components/widgets';
import AddFutureItems from '../containers/AddFutureItems';
import { MEMBER_TYPES, translationPrefix } from '../utils';
import MultiColStepCard from './MultiColStepCard';
import css from './ScreenPageStep.css';
import WizardWarningMessage from './WizardWarningMessage';

const ScreenPageStep = ({ screens, screenSelectionForm: { selectedScreens }, toggleScreens, activeMemberType }) => {
    const handleScreenChange = (screen, newState) => toggleScreens([screen.name], newState);

    const renderScreen = screen => (
        <div key={screen.name} className={css.screenContainer}>
            <Tooltip title={screen.disabledTooltip} disabled={!screen.disabledTooltip}>
                <Checkbox
                    size="small"
                    label={screen.displayName}
                    checked={selectedScreens.includes(screen.name)}
                    disabled={screen.disabled}
                    onChange={newState => handleScreenChange(screen, newState)}
                />
            </Tooltip>
            {screen.warning && <Icon name="info-triangle" size={IconSizes.X_SMALL} variant={IconVariants.WARNING} />}
        </div>
    );

    return (
        <div className={css.container}>
            {screens.some(section => section.children.some(screen => screen.warning)) && (
                <WizardWarningMessage show message={`${translationPrefix}.SCREEN_SELECTION_WARNING`} />
            )}
            <MultiColStepCard
                title={`${translationPrefix}.MANAGE_PERMISSIONS_PAGE.TITLE.SCREENS`}
                description={`${translationPrefix}.MANAGE_PERMISSIONS_PAGE.DESCRIPTION.SCREENS`}
                items={screens.map(section => ({
                    title: section.displayName,
                    children: section.children.map(renderScreen),
                }))}
                contentClassName={css.stepCardContent}
            />
            {activeMemberType !== MEMBER_TYPES.AGENCY && (
                <AddFutureItems itemType="screens" form="screenSelectionForm" className={css.addFutureItems} />
            )}
        </div>
    );
};

ScreenPageStep.propTypes = {
    screens: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            displayName: PropTypes.string.isRequired,
            children: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired,
                    displayName: PropTypes.string.isRequired,
                    warning: PropTypes.bool.isRequired,
                    disabled: PropTypes.bool.isRequired,
                    disabledTooltip: PropTypes.string,
                })
            ).isRequired,
        })
    ).isRequired,
    screenSelectionForm: PropTypes.shape({
        selectedScreens: PropTypes.arrayOf(PropTypes.string).isRequired,
        addFuture: PropTypes.bool.isRequired,
    }).isRequired,
    toggleScreens: PropTypes.func.isRequired,
    activeMemberType: PropTypes.string.isRequired,
};

export default ScreenPageStep;
